<div class="edit-page-root-container shift-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" [readonly]="shiftInfo.id!==undefined && shiftInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" maxlength="100">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <div class="time-field-group">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Start Hour</mat-label>
                                        <mat-select [value]="start_hour" (selectionChange)="start_hour = $event.value; updateStartTime()">
                                            <mat-option *ngFor="let h of hours" [value]="h">{{ h }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="time-separator">:</span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Min</mat-label>
                                        <mat-select [value]="start_min" (selectionChange)="start_min = $event.value; updateStartTime()">
                                            <mat-option *ngFor="let m of minutes" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <mat-error *ngIf="editForm.controls['start_time'].touched && editForm.controls['start_time'].hasError('required')" style="font-size: 75%; margin-top: -15px; margin-bottom: 15px; display: block;">Start time is required</mat-error>
                            </div>
                            <div class="input-box-right">
                                <div class="time-field-group">
                                    <mat-form-field appearance="outline">
                                        <mat-label>End Hour</mat-label>
                                        <mat-select [value]="end_hour" (selectionChange)="end_hour = $event.value; updateEndTime()">
                                            <mat-option *ngFor="let h of hours" [value]="h">{{ h }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="time-separator">:</span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Min</mat-label>
                                        <mat-select [value]="end_min" (selectionChange)="end_min = $event.value; updateEndTime()">
                                            <mat-option *ngFor="let m of minutes" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <mat-error *ngIf="editForm.controls['end_time'].touched && editForm.controls['end_time'].hasError('required')" style="font-size: 75%; margin-top: -15px; margin-bottom: 15px; display: block;">End time is required</mat-error>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left" style="display: flex; align-items: center; gap: 20px; padding-bottom: 20px;">
                                <mat-checkbox formControlName="is_active">Is Active</mat-checkbox>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" rows="5"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
